module.exports = __webpack_public_path__ + "media/customizations/trillium/logo-new-fbc348f4d50f8a524ffe51d9d343309c.png";